import { useState } from 'react';
import { Star } from 'lucide-react';

/**
 * Interactive 1-5 star selector.
 */
export default function StarPicker({ value = 0, onChange, size = 28, disabled = false }) {
	const [hover, setHover] = useState(0);
	const display = hover || value;
	return (
		<div
			className="inline-flex items-center gap-1"
			data-testid="star-picker"
			onMouseLeave={() => setHover(0)}
		>
			{[1, 2, 3, 4, 5].map((n) => (
				<button
					key={n}
					type="button"
					disabled={disabled}
					onMouseEnter={() => !disabled && setHover(n)}
					onClick={() => !disabled && onChange?.(n)}
					className={`transition-transform ${disabled ? 'cursor-default' : 'hover:scale-110 cursor-pointer'}`}
					data-testid={`star-picker-${n}`}
					aria-label={`${n} stars`}
				>
					<Star
						style={{ width: size, height: size }}
						className={n <= display ? 'fill-[#D4AF37] text-[#D4AF37]' : 'text-[#D4C5A9]'}
					/>
				</button>
			))}
		</div>
	);
}